import { Link } from "react-router-dom";
import { Play, Clock, TrendingUp } from "lucide-react";
import { Badge } from "./ui/badge";
import { formatDuration } from "../lib/format";
import { resolveImageUrl } from "../lib/images";

const CourseCard = ({ course }) => {
  return (
    <Link
      to={`/curso/${course.id}`}
      className="group relative aspect-video bg-card rounded-md overflow-hidden border border-white/5 hover:border-white/20 transition-all duration-300 hover:scale-105 hover:z-10 hover:shadow-2xl course-card"
      data-testid={`course-card-${course.id}`}
    >
      <div className="absolute inset-0">
        <img
          src={resolveImageUrl(course.image_url)}
          alt={course.title}
          width={1280}
          height={720}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
      </div>

      <div className="absolute inset-0 flex flex-col justify-end p-4">
        <div className="flex items-center gap-2 mb-2">
          <Badge
            className={
              course.tier === "PRO"
                ? "bg-[#E50914] text-white border-0"
                : "bg-white/10 text-white border-white/20"
            }
            data-testid={`course-tier-${course.tier}`}
          >
            {course.tier}
          </Badge>
          <Badge className="bg-white/10 text-white border-white/20">
            {course.level}
          </Badge>
        </div>

        <h3 className="text-white font-semibold text-base mb-2 line-clamp-2 group-hover:text-[#E50914] transition-colors">
          {course.title}
        </h3>

        <div className="flex items-center gap-4 text-white/60 text-xs">
          <div className="flex items-center gap-1">
            <Clock className="w-3 h-3" />
            <span>{formatDuration(course.duration_hours)}</span>
          </div>
          <div className="flex items-center gap-1">
            <TrendingUp className="w-3 h-3" />
            <span>{course.category}</span>
          </div>
        </div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="w-16 h-16 rounded-full bg-[#E50914]/90 flex items-center justify-center">
          <Play className="w-8 h-8 text-white fill-white" />
        </div>
      </div>
    </Link>
  );
};

export default CourseCard;
